<div class="top-control-container">

  <div class="top-left-container">
    <div class="results-count">
      @if (loading) {
        <mat-spinner diameter="20"></mat-spinner>
      } @else {
        Results: 
        <span class="ml-3" [class.no-results]="results.data.length === 0">
          {{ results.data.length | number }}
        </span>
      }
    </div>

    @if(!isMobile) {
      <button mat-icon-button (click)="runSearch(true, true)" matTooltip="Refresh" [disabled]="loading">
        <mat-icon>refresh</mat-icon>
      </button>
    }

  </div>
  
  @if (!isMobile) {
    <div class="filters-container">
      <mat-chip-set>
        @for (chip of filterChips; track chip.key) {
          <mat-chip-row
            (click)="chip.action()"
            [removable]="chip.removable"
            (removed)="removeFilter(chip.key)"
          >
            {{ chip.label }}

            @if (chip.removable) {
              <button matChipRemove>
                <mat-icon>cancel</mat-icon>
              </button>
            }
          </mat-chip-row>
        }
      </mat-chip-set>

      <button mat-icon-button [matMenuTriggerFor]="menu" matTooltip="Add Filter">
        <mat-icon>add_circle_outline</mat-icon>
      </button>
      <mat-menu #menu="matMenu">
        @for (availableFilter of availableFilters; track availableFilter.key) {
          <button mat-menu-item (click)="addFilter(availableFilter.key)">
            {{ availableFilter.label }}
          </button>
        }
      </mat-menu>
    </div>
  }
  
  <div class="top-right-container">

    @if(!isMobile) {
      <button mat-stroked-button (click)="updateSearch()" [disabled]="loading">
        Filters
      </button>
    } @else {

      <button
        mat-icon-button
        (click)="goBack()"
        matTooltip="Back"
      >
        <mat-icon>arrow_back</mat-icon>
      </button>

      <button mat-icon-button (click)="runSearch(true, true)" matTooltip="Refresh" [disabled]="loading">
        <mat-icon>refresh</mat-icon>
      </button>

      <button
        mat-icon-button
        (click)="updateSearch()"
        [disabled]="loading"
        matTooltip="Filters"
      >
        <mat-icon>filter_list</mat-icon>
      </button>

      <button
        mat-icon-button
        [matMenuTriggerFor]="sortMenu"
        matTooltip="Sort"
        type="button"
      >
        <mat-icon>sort</mat-icon>
      </button>

      <mat-menu #sortMenu="matMenu">

        <button mat-menu-item type="button" (click)="sortBy('refreshed_at', 'desc')">
          <mat-icon>schedule</mat-icon>
          <span>Newest</span>
        </button>

        <button mat-menu-item type="button" (click)="sortBy('rate', 'desc')">
          <mat-icon>attach_money</mat-icon>
          <span>Rate: High to Low</span>
        </button>

        <button mat-menu-item type="button" (click)="sortBy('rpm', 'desc')">
          <mat-icon>trending_up</mat-icon>
          <span>RPM: High to Low</span>
        </button>

        <button mat-menu-item type="button" (click)="sortBy('origin_deadhead_distance', 'asc')">
          <mat-icon>near_me</mat-icon>
          <span>Deadhead: Low to High</span>
        </button>

        <button mat-menu-item type="button" (click)="sortBy('distance', 'asc')">
          <mat-icon>straighten</mat-icon>
          <span>Distance: Low to High</span>
        </button>

        <mat-divider></mat-divider>

        <button mat-menu-item type="button" (click)="clearSort()">
          <mat-icon>clear</mat-icon>
          <span>Clear Sort</span>
        </button>

      </mat-menu>
    }

  </div>
</div>

<table
  mat-table
  [dataSource]="results"
  matSort
  class="results-table"
> 

  <!-- Mobile Column -->
  <ng-container matColumnDef="mobile">
    <th mat-header-cell *matHeaderCellDef></th>

    <td mat-cell *matCellDef="let load">
      <div class="mobile-load-cell">

        <button
          mat-icon-button
          class="mobile-save-button"
          (click)="toggleSavedLoad(load); $event.stopPropagation()"
        >
          <mat-icon [class.saved]="load.is_saved">
            {{ load.is_saved ? 'favorite' : 'favorite_border' }}
          </mat-icon>
        </button>

        <div class="mobile-location-row">
          <span class="location-marker filled"></span>

          <div class="location-text">
            {{ load.origin_city | titlecase }}, {{ load.origin_state }}

            @if (load.origin_deadhead_distance) {
              <span class="deadhead-distance">
                ({{ load.origin_deadhead_distance }})
              </span>
            }

            @if (load.origin_start_date === load.origin_end_date) {
              <span class="dates">
                ({{ load.origin_start_date | date: 'MM/dd' }})
              </span>
            } @else {
              <span class="dates">
                ({{ load.origin_start_date | date: 'MM/dd' }} -
                {{ load.origin_end_date | date: 'MM/dd' }})
              </span>
            }
          </div>
        </div>

        <div class="mobile-middle-row">
          <span class="location-connector"></span>

          <span class="middle-text">
            {{ load.distance | number }} mi
          </span>
        </div>

        <div class="mobile-location-row mb-10">
          <span class="location-marker"></span>

          <div class="location-text">
            {{ load.destination_city | titlecase }}, {{ load.destination_state }}

            @if (load.destination_deadhead_distance) {
              <span class="deadhead-distance">
                ({{ load.destination_deadhead_distance }})
              </span>
            }

            @if (load.destination_start_date === load.destination_end_date) {
              <span class="dates">
                ({{ load.destination_start_date | date: 'MM/dd' }})
              </span>
            } @else {
              <span class="dates">
                ({{ load.destination_start_date | date: 'MM/dd' }} -
                {{ load.destination_end_date | date: 'MM/dd' }})
              </span>
            }
          </div>
        </div>

        @if (load.rate) {
          <div class="mobile-details">
            <span class="mobile-rate">
              {{ load.rate | currency:'USD':'symbol':'1.0-0' }}
            </span>

            <span class="mobile-rpm">
              ({{ load.rpm | currency:'USD':'symbol':'1.0-2' }} per mi)
            </span>
          </div>
        }

        <div class="mobile-details">
          {{ load.weight | number }} lbs
          <br />
          {{ getDimensions(load) }}
          <br />
          Well Required: {{ toFeetAndInches(load.well_length) }}
        </div>

        <div class="mobile-details">
          Age: {{ formatAge(load.refreshed_since) }}
        </div>

        <div class="mobile-details">
          {{ load.carrier_name }}
        </div>

      </div>
    </td>
  </ng-container>

  <!-- Desktop Columns -->
  <ng-container matColumnDef="is_saved">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>Saved</th>

    <td mat-cell *matCellDef="let load">
      <button mat-icon-button (click)="toggleSavedLoad(load); $event.stopPropagation()">
        <mat-icon [class.saved]="load.is_saved">
          {{ load.is_saved ? 'favorite' : 'favorite_border' }}
        </mat-icon>
      </button>
    </td>
  </ng-container>

  <ng-container matColumnDef="age">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>
      Age
    </th>
    <td mat-cell *matCellDef="let load">
      {{ formatAge(load.refreshed_since) }}
    </td>
  </ng-container>

  <ng-container matColumnDef="pickup_dates">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>
      Pickup
    </th>
    <td mat-cell *matCellDef="let load">
      @if(load.origin_start_date === load.origin_end_date) {
        {{ load.origin_start_date | date: 'MM/dd' }}
      } @else {
        {{ load.origin_start_date | date: 'MM/dd' }} -
        {{ load.origin_end_date | date: 'MM/dd' }}
      }
    </td>
  </ng-container>

  <ng-container matColumnDef="rate">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>
      Rate
    </th>
    <td mat-cell *matCellDef="let load">
      {{ load.rate | currency:'USD':'symbol':'1.0-0' }}
    </td>
  </ng-container>

  <ng-container matColumnDef="rpm">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>
      RPM
    </th>
    <td mat-cell *matCellDef="let load">
      {{ load.rpm | currency }}
    </td>
  </ng-container>

  <ng-container matColumnDef="origin_deadhead_distance">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>
      DH
    </th>
    <td mat-cell *matCellDef="let load">
      {{ load.origin_deadhead_distance }}
    </td>
  </ng-container>

  <ng-container matColumnDef="origin_city">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>
      Origin
    </th>
    <td mat-cell *matCellDef="let load">
      {{ load.origin_city }}
    </td>
  </ng-container>

  <ng-container matColumnDef="origin_state">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>
      ST
    </th>
    <td mat-cell *matCellDef="let load">
      {{ load.origin_state }}
    </td>
  </ng-container>

  <ng-container matColumnDef="destination_deadhead_distance">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>
      DH
    </th>
    <td mat-cell *matCellDef="let load">
      {{ load.destination_deadhead_distance }}
    </td>
  </ng-container>

  <ng-container matColumnDef="destination_city">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>
      Destination
    </th>
    <td mat-cell *matCellDef="let load">
      {{ load.destination_city }}
    </td>
  </ng-container>

  <ng-container matColumnDef="destination_state">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>
      ST
    </th>
    <td mat-cell *matCellDef="let load">
      {{ load.destination_state }}
    </td>
  </ng-container>

  <ng-container matColumnDef="distance">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>
      Distance
    </th>
    <td mat-cell *matCellDef="let load">
      {{ load.distance | number  }}
    </td>
  </ng-container>

  <ng-container matColumnDef="weight">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>
      Weight
    </th>
    <td mat-cell *matCellDef="let load">
      {{ load.weight | number }}
    </td>
  </ng-container>

  <ng-container matColumnDef="dimensions">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>
      L x W x H
    </th>
    <td mat-cell *matCellDef="let load">
      {{ getDimensions(load) }}
    </td>
  </ng-container>

  <ng-container matColumnDef="well_required">
    <th mat-header-cell *matHeaderCellDef mat-sort-header matTooltip="Well Length Required">
      Well
    </th>
    <td mat-cell *matCellDef="let load">
      {{ toFeetAndInches(load.well_length) }}
    </td>
  </ng-container>

  <ng-container matColumnDef="carrier_name">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>
      Broker
    </th>
    <td mat-cell *matCellDef="let load">
      {{ load.carrier_name }}
    </td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="displayedColumns" [hidden]="results.data.length === 0"></tr>
  <tr
    mat-row
    *matRowDef="let row; columns: displayedColumns"
    [class.new-row]="isFresh(row)"
    (click)="viewLoadDetails(row)"
    class="clickable-row"
  ></tr>

  <tr class="mat-row" *matNoDataRow>
    <td
      class="no-results-cell"
      [attr.colspan]="displayedColumns.length"
    >
      @if (loading) {
        <mat-spinner diameter="24"></mat-spinner>
      } @else {
        <div class="yellow-container">
          No loads found. Try adjusting your filters or refreshing the search.
        </div>
      }
    </td>
  </tr>
</table>

<br />

<mat-paginator
  [style.display]="results.data.length === 0 ? 'none' : ''"
  [pageSize]="itemsPerPage"
  [pageSizeOptions]="[10, 25, 50, 100]"
  showFirstLastButtons
></mat-paginator>
